import './App.css';
import React, {useState} from 'react'
import Header from './components/Header'
import Sidebar from './components/Sidebar'
import { BrowserRouter as Router, Switch,Route} from 'react-router-dom'
import Chat from './components/Chat'
import Login from './components/Login'
import {useStateValue} from './components/StateProvider'
import Welcome from './components/Welcome'


function App() {
  const [{user},dispatch]=useStateValue()
  return (
    <div className="App">
          <Router>      
           { !user ? (<Login />) : 
           <>
           <Header/>
           <div className="app__body">
           <Sidebar/>
           <Switch>
              <Route path="/room/:roomId">
              <Chat/>
              </Route>
              <Route path="/">
                <Welcome />
              </Route>
           </Switch>       
           </div> </> }
          
          </Router>
    </div>
  );
}

export default App;
